import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './MultiPose.module.scss';
import fullHeartIcon from '../../../assets/heart.png';
import clearForegrounds from '../../../assets/Clear_Foreground.png';
import useImageOrientation, { ORIENTATION } from '../../../hooks/useImageOrientation';

export default function CarouselItem({
  favoriteIds, item, useOrientation, onClick, background,
}) {
  const { orientation } = useImageOrientation(item.watermarkUrl || item.imageUrl);

  // The img alt doubles as the tile button's accessible name — backgrounds carry
  // their color name, poses their number.
  const label = item.color || (item.number ? `Pose ${item.number}` : 'Photo option');

  // Every branch renders width-filling imgs (carouselImage): without it the img only
  // gets max-width, and any file narrower than the tile — the legacy 218px-wide
  // backgrounds (Senior_Grey/Green/Purple/White), the 384px clear-foreground tile —
  // renders at natural size, visibly smaller than its neighbors. The redesigned
  // full-width builder made tiles that wide for the first time.
  let content;
  if (item.id === 99999) {
    content = <img alt="No foreground" src={clearForegrounds} className={styles.carouselImage} />;
  } else if (background) {
    content = (
      <>
        <img alt={label} src={item.watermarkUrl || item.imageUrl} className={styles.carouselImage} />
        <img alt="" src={background.imageUrl} className={styles.carouselBackground} />
      </>
    );
  } else {
    content = <img alt={label} src={item.watermarkUrl || item.imageUrl} className={styles.carouselImage} />;
  }

  return (
    <button
      className={cn(styles.carouselItem, {
        [styles.landscapeItem]: orientation === ORIENTATION.LANDSCAPE,
        [styles.hidden]: useOrientation && orientation !== useOrientation && item.id !== 99999,
      })}
      onClick={onClick}
      type="button"
    >
      {content}

      {favoriteIds.includes(item.id) && (
        <img alt="Favorite Item" className={styles.favoriteIcon} src={fullHeartIcon} />
      )}
    </button>
  );
}

CarouselItem.propTypes = {
  favoriteIds: PropTypes.arrayOf(PropTypes.string),
  item: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    color: PropTypes.string,
    number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    watermarkUrl: PropTypes.string,
    imageUrl: PropTypes.string,
  }).isRequired,
  useOrientation: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  background: PropTypes.shape({
    imageUrl: PropTypes.string,
  }),
};

CarouselItem.defaultProps = {
  favoriteIds: [],
  useOrientation: null,
  background: null,
};
